import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manual-claim',
  templateUrl: './manual-claim.component.html',
  styleUrls: ['./manual-claim.component.scss']
})
export class ManualClaimComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
